var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{staticClass:"d-inline-block",attrs:{"name":_vm.transition}},[(_vm.change)?_c('div',{key:"1"},[_vm._v(" "+_vm._s(_vm.value1)+" ")]):_c('div',{key:"2"},[_vm._v(" "+_vm._s(_vm.value2)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }